import { MiniCartProps } from "@made-people/blueprint-mini-cart";
import { MMMinicartUpsell } from "../../global/MMMiniCartUpsell";
import { MMTrustLogos } from "../../global/MMTrustLogos";
import { MMFreeShippingBanner } from "../../global/MMFreeShippingBanner";

export const MiniCart: MiniCartProps = {
  settings: {
    template: "lyon",
    hasEmptyState: true,
    cartTotals: {
      fieldsEnabled: {
        subtotal: true,
        discount: false,
        tax: false,
        shipping: true,
        grandTotal: true,
      },
    },
    aboveCartItemsContent: <MMFreeShippingBanner />,
    miniCartUpsellContent: <MMMinicartUpsell />,
    trustLogosBanner: <MMTrustLogos maxLogos={4} />,
  },
};
